import { createRecipe } from './runtime';

const tagConfig = {"name":"tag","defaultVariants":{"mono":false,"tone":"neutral"},"variantMap":{"mono":["false","true"],"tone":["accent","deny","neutral","ok","warn"]}}

export const tag = /* @__PURE__ */ createRecipe(tagConfig)